// 比如doc/docx、xls/xlsx、ppt/pptx、pdf、txt、rar/zip/gz/7z、jpg/jpeg/png、mp4展示对应的图标，无后缀或其他后缀就展示如下图这个空白图标
export default function(fileName) {
  // 获取文件后缀
  const suffix = fileName.split('.').pop();

  const icons = {
    // word
    doc: 'attach_word',
    docx: 'attach_word',

    // excel
    xls: 'attach_excel',
    xlsx: 'attach_excel',

    // ppt
    ppt: 'attach_ppt',
    pptx: 'attach_ppt',

    // pdf
    pdf: 'attach_pdf',

    // 压缩包
    rar: 'attach_zip',
    zip: 'attach_zip',
    gz: 'attach_zip',
    '7z': 'attach_zip',

    // 图片
    jpg: 'attach_image',
    jpeg: 'attach_image',
    png: 'attach_image',

    // 视频
    mp4: 'attach_video',

    // 通用
    general: 'attach_general',

    // 无后缀或其他后缀
    default: 'attach_default',
  };

  // 无后缀或其他后缀
  if (!suffix) {
    return icons.default;
  }

  if (fileName && suffix && icons[suffix]) {
    return icons[suffix];
  }
  // 通用
  return icons.default;
}
